const categories = [
  {
    icon: "ri-dice-line",
    title: "Juegos de mesa colombianos",
    text: "Parqués, dominó, bingo y juegos de cartas originales creados por Iokus.",
  },
  {
    icon: "ri-shapes-line",
    title: "Juguetes de madera para los más pequeños",
    text: "Arrastres, instrumentos, animales y vehículos en madera natural.",
  },
  {
    icon: "ri-puzzle-2-line",
    title: "Rompecabezas y coleccionables",
    text: "Piezas de Colombia y de arte, ideales para llevar de recuerdo.",
  },
];

export default function WhatYouFind() {
  return (
    <section id="encontrar" className="w-full scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="reveal mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <h2 className="text-3xl font-semibold md:text-[40px]">Qué vas a encontrar</h2>
          <p className="mt-4 text-base text-foreground-600 md:text-lg">
            Madera, color y juegos para todas las edades, hechos a mano en Colombia.
          </p>
        </div>

        <div className="grid gap-4 md:gap-5">
          {categories.map((category) => (
            <div
              key={category.title}
              className="reveal flex flex-col gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 sm:flex-row sm:items-center sm:gap-6 md:p-6"
            >
              <span className="flex h-14 w-14 flex-none items-center justify-center rounded-2xl bg-primary-100 text-primary-800">
                <i className={`${category.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="text-lg font-semibold md:text-xl">{category.title}</h3>
                <p className="mt-1 text-sm text-foreground-600 md:text-base">{category.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="reveal mt-6 flex items-center gap-4 rounded-2xl bg-accent-50 p-5 md:mt-8 md:p-7">
          <i className="ri-lightbulb-flash-line hidden text-3xl text-accent-600 sm:block" aria-hidden="true"></i>
          <p className="text-base font-heading font-semibold leading-snug text-accent-900 md:text-xl">
            Iokus uniendo generaciones alrededor de los juegos y juguetes.
          </p>
        </div>
      </div>
    </section>
  );
}